export const VERSION = '1.15.0';
